import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import router from './router'
import VueApexCharts from 'vue3-apexcharts'
import VueGoogleMaps from '@fawmi/vue-google-maps'

const app = createApp(App)

app.use(router)
app.use(VueApexCharts)
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCv9jSWD-olzkeBa82SWqnPkbNcOr2MjME',
  },
})

app.mount('#app')
